<template>
  <div class="suggestion-list-container flex flex-col">
    <template v-if="singleCheckLoading && !list.length">
      <span class="check-loading-text">正在检查，请稍等...</span>
    </template>
    <template v-else-if="list.length">
      <template v-for="(item, index) in list">
        <div
          :key="index"
          class="suggestion-list-item flex items-start"
          :class="item.impact"
        >
          <div
            class="content flex-1 select-text"
            :class="{
              resolved:
                item.status === 'answered' || item.status === 'obsolete',
            }"
          >
            {{ item.content }}
          </div>
          <div
            class="ignore flex-shrink-0 flex items-center"
            :class="{ 'cursor-pointer': item.status === 'not_answered' }"
            @click.stop="clickIgnore(item)"
          >
            <i
              v-if="item.status === 'answered'"
              class="iconfont iconxuanzhong"
            ></i>
            {{
              item.status === "answered"
                ? "已优化"
                : item.status === "obsolete"
                ? "已忽略"
                : "忽略"
            }}
          </div>
        </div>
      </template>
    </template>
    <!-- 非会员 && 有结果 -->
    <div
      v-if="!this.isMembership && list.length && showNormalTips"
      class="normal-content"
    >
      <img :src="images[personInfo.theme]" />
      <div class="common-btn" @click="handleOpenMemberDialog">
        开通会员查看结果
      </div>
    </div>
    <div v-if="!hiddenBottomBtn" class="flex items-center button-group">
      <button
        class="btn-item flex-1 flex justify-center items-center"
        @click="clickAiCheck"
      >
        <i
          class="iconfont iconhuanyihuan1"
          :class="{ 'optimized-spinner': singleCheckLoading && list.length }"
        ></i>
        {{ singleCheckLoading && list.length ? `检查中${dotsCheck}` : "重新检查" }}
      </button>
      <button
        class="btn-item flex-1 flex justify-center items-center"
        @click="clickRepairIssue"
      >
        <i class="iconfont iconFrame1"></i>
        一键修复问题{{ repaireIssueCheck }}
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CompleteButton from "../../components/CompleteButton/CompleteButton.vue";
export default {
  name: "CheckSuggestionList",
  components: {
    CompleteButton,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    hiddenBottomBtn: {
      type: Boolean,
      default: false,
    },
    showNormalTips: {
      type: Boolean,
      default: false,
    },
    repairIssueLoading: {
      type: Boolean,
      default: false,
    },
    singleCheckLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      images: {
        dark: "https://files.wondercv.com/cvs/normal-dark-CheckSuggestion.png",
        light:
          "https://files.wondercv.com/cvs/normal-light-CheckSuggestion.png",
      },
      checkDotCount: 0,
      repaireIssueCheckCount: 0,
      checkDotCountTimer: null,
      repaireIssueCheckTimer: null,
    };
  },
  computed: {
    ...mapState("me", ["personInfo", "isMembership"]),
    dotsCheck() {
      return ".".repeat(this.checkDotCount % 4);
    },
    repaireIssueCheck() {
      return ".".repeat(this.repaireIssueCheckCount % 4);
    },
  },
  watch: {
    singleCheckLoading(newVal) {
      if (newVal) {
        this.checkDotCountTimer = setInterval(() => {
          this.checkDotCount = (this.checkDotCount + 1) % 4;
        }, 500);
      } else {
        clearInterval(this.checkDotCountTimer);
        this.checkDotCount = 0;
      }
    },
    repairIssueLoading(newVal) {
      if (newVal) {
        this.repaireIssueCheckTimer = setInterval(() => {
          this.repaireIssueCheckCount = (this.repaireIssueCheckCount + 1) % 4;
        }, 500);
      } else {
        clearInterval(this.repaireIssueCheckTimer);
        this.repaireIssueCheckCount = 0;
      }
    },
  },
  methods: {
    clickRepairIssue() {
      if (this.isMembership) {
        if (this.repairIssueLoading) return;
        this.$emit("clickRepairIssue");
      } else {
        this.$message.error("该功能为会员专享");
        this.$emit("buyMember");
      }
    },
    clickIgnore(item) {
      if (item.status === "answered") return;
      this.$emit("clickIgnore", item);
    },
    clickAiCheck() {
      this.$emit("clickAiCheck");
    },
    handleOpenMemberDialog() {
      this.$emit("buyMember");
    },
  },
  beforeDestroy() {
    clearInterval(this.checkDotCountTimer);
    clearInterval(this.repaireIssueCheckTimer);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.suggestion-list-container {
  gap: 10px;
  .check-loading-text {
    color: $text-color;
    font-size: 16px;
    font-weight: 600;
  }
  .suggestion-list-item {
    position: relative;
    color: $text-color;
    background-color: $resume-check-suggestion-bg-color;
    padding: 12px 18px 12px 22px;
    border-radius: 6px;
    overflow: hidden;
    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0;
      width: 6px;
      height: 100%;
    }
    &.LOW::before {
      background: linear-gradient(
        to right,
        $resume-check-low-start-color,
        $resume-check-low-end-color
      );
    }
    &.MEDIUM::before {
      background: linear-gradient(
        to right,
        $resume-check-medium-start-color,
        $resume-check-medium-end-color
      );
    }
    &.HIGH::before {
      background: linear-gradient(
        to right,
        $resume-check-high-start-color,
        $resume-check-high-end-color
      );
    }
    .content {
      user-select: text;
      &.resolved {
        text-decoration: line-through;
        opacity: 0.6;
      }
    }
    .ignore {
      font-size: 14px;
      color: $resume-check-suggestion-ignore-color;
      margin-left: 18px;
      .iconxuanzhong {
        margin-right: 6px;
        color: $text-color;
        opacity: 0.6;
      }
    }
  }
  .button-group {
    display: flex;
    gap: 16px;
    margin-top: 18px;
    .btn-item {
      color: $text-color;
      border: 1px solid $advice-border-color;
      border-radius: 6px;
      height: 42px;
      i {
        margin-right: 4px;
      }
    }
  }
  .normal-content {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: 80px;
    }
    .common-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 32px;
      background: linear-gradient(270deg, #e15d3f 0%, #febf5d 100%);
      color: #fff;
      border-radius: 999px;
      box-sizing: border-box;
      cursor: pointer;
      padding: 0 16px;
      width: max-content;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      &:hover {
        background-color: #ff8569;
      }
    }
  }

  /* 定义旋转动画 */
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  /* 高性能优化版（启用GPU加速） */
  .optimized-spinner {
    animation: spin 1s linear infinite;
    will-change: transform; /* 提前告知浏览器动画属性 */
    backface-visibility: hidden; /* 修复Webkit渲染抖动 */
  }
}
</style>
